(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cust-review-video-card"] && !Shopify.designMode) return;
  try {
    

function cus_rvw_str_vde__initSlider() {

  if (typeof Flickity === 'undefined') return;

  document.querySelectorAll('.js-cus_rvw_str_vde__slider').forEach(function (slider) {

    if (slider.classList.contains('flickity-enabled')) return;

    new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      imagesLoaded: true,
      draggable: true,
      adaptiveHeight: false,
      groupCells: false,
      pageDots: slider.dataset.dots === 'true',
      prevNextButtons: slider.dataset.arrows === 'true',
      autoPlay: slider.dataset.autoplay === 'true'
        ? parseInt(slider.dataset.duration)
        : false
    });

  });

}

document.addEventListener('DOMContentLoaded', function () {
  cus_rvw_str_vde__initSlider();
});

document.addEventListener('shopify:section:load', function () {
  cus_rvw_str_vde__initSlider();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
